"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEventsForClass = void 0;
const types_1 = require("./types");
function makeEventsForClass(cls, additionalEvents) {
    const newEnum = {
        getEventFromEnumValue(value) {
            return this.getEventFromString(value);
        },
        getEventFromString(value) {
            if (value) {
                const eventName = `entity.${cls.name}.${value}`;
                const eventKey = Object.keys(this).find((key) => this[key] === eventName);
                if (eventKey) {
                    return this[eventKey];
                }
            }
        },
    };
    for (const [k, v] of Object.entries(types_1.DefaultEntityEvents)) {
        newEnum[k] = `entity.${cls.name}.${v}`;
    }
    if (additionalEvents) {
        for (const [k, v] of Object.entries(additionalEvents)) {
            newEnum[k] = `entity.${cls.name}.${v}`;
        }
    }
    return newEnum;
}
exports.makeEventsForClass = makeEventsForClass;
//# sourceMappingURL=make-events.js.map